import { RiGroup2Line, RiGroupLine } from "react-icons/ri"
import NavCard from "../../Partials/Layouts/NavCardList/NavCard/NavCard"
import NavCardList from "../../Partials/Layouts/NavCardList/NavCardList"
import BackButton from "../../Partials/Elements/BackButton/BackButton"

function ProducerScreen() {
    return (
        <div style={{ display: "flex", flexDirection: "column", paddingTop: "40px", gap: "20px" }}>
            <BackButton />
            <NavCardList numOfCards={'two'}>
                <NavCard cardName={'Producers'} navCardLink='/producers' ><RiGroup2Line /></NavCard>
                <NavCard cardName={'Producer Invites'} navCardLink='/producerInvites' ><RiGroupLine /></NavCard>
               
            </NavCardList>

        </div>
    )
}

export default ProducerScreen